// components/Clarity.js
import { useEffect } from 'react';
import { CLARITY_KEY } from 'sysconfig';

const Clarity = () => {
  useEffect(() => {
    if (CLARITY_KEY != '') {
      (function (c, l, a, r, i, t, y) {
        c[a] =
          c[a] ||
          function () {
            (c[a].q = c[a].q || []).push(arguments);
          };
        t = l.createElement(r);
        t.async = 1;
        t.src = 'https://www.clarity.ms/tag/' + i;
        y = l.getElementsByTagName(r)[0];
        y.parentNode.insertBefore(t, y);
      })(window, document, 'clarity', 'script', CLARITY_KEY);
    }
  }, []);

  return null;
};

export default Clarity;
